"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThrottledSearchBox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Search_1 = __importDefault(require("@mui/icons-material/Search"));
const Cancel_1 = __importDefault(require("@mui/icons-material/Cancel"));
const react_1 = require("react");
const constants_1 = require("../constants");
function SearchBox({ TextFieldProps, onCancel, }) {
    var _a;
    return ((0, jsx_runtime_1.jsx)(material_1.TextField, Object.assign({}, TextFieldProps, { InputProps: Object.assign(Object.assign({}, TextFieldProps === null || TextFieldProps === void 0 ? void 0 : TextFieldProps.InputProps), { startAdornment: ((_a = TextFieldProps === null || TextFieldProps === void 0 ? void 0 : TextFieldProps.InputProps) === null || _a === void 0 ? void 0 : _a.startAdornment) || ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, Object.assign({ position: "start" }, { children: (0, jsx_runtime_1.jsx)(Search_1.default, {}) }))), endAdornment: ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, Object.assign({ position: "end" }, { children: onCancel ? ((0, jsx_runtime_1.jsx)(material_1.IconButton, Object.assign({ onClick: onCancel }, { children: (0, jsx_runtime_1.jsx)(Cancel_1.default, {}) }))) : null }))) }) })));
}
exports.default = SearchBox;
// An (uncontrolled) throttled version of the SearchBox.
// Helps reduce the number of state changes & re-renders in
// consuming components when the list of things to filter
// is large, and filtering is done client-side.
function ThrottledSearchBox({ onFilterChanged, TextFieldProps, testId, throttleDurationMs = constants_1.GLOBAL_THROTTLE_DELAY, cancellable = true, }) {
    const [gen, setGen] = (0, react_1.useState)(0);
    const ref = (0, react_1.useRef)({
        timeout: null,
        lastInput: "",
    });
    const updateFilter = (e) => {
        ref.current.lastInput = e == "" ? "" : e.target.value;
        if (ref.current.timeout != null) {
            clearTimeout(ref.current.timeout);
        }
        ref.current.timeout = setTimeout(() => {
            onFilterChanged(ref.current.lastInput);
        }, throttleDurationMs);
    };
    return ((0, jsx_runtime_1.jsx)(SearchBox, { "data-testid": testId, TextFieldProps: Object.assign(Object.assign({}, TextFieldProps), { onChange: (e) => updateFilter(e) }), onCancel: cancellable
            ? () => {
                // Fast-path for clearing the filter with the button (not throttled like the updateFilter path)
                setGen((gen) => gen + 1);
                ref.current.lastInput = "";
                if (ref.current.timeout) {
                    clearTimeout(ref.current.timeout);
                }
                ref.current.timeout = null;
                onFilterChanged("");
            }
            : undefined }, gen));
}
exports.ThrottledSearchBox = ThrottledSearchBox;
